<div class="tab-toggle" :class="{ 'tab-toggle--small': size === 'small' }" role="group" :aria-label="resolvedAriaLabel">
  <button
    v-for="option in options"
    :key="getOptionValue(option)"
    type="button"
    class="tab-toggle__option"
    :class="{ 'tab-toggle__option--active': isActive(option) }"
    :aria-pressed="isActive(option)"
    :disabled="disabled || option.disabled"
    @click="selectOption(option)"
  >
    <i v-if="option.icon" :class="option.icon"></i>
    <span>{{ getOptionLabel(option) }}</span>
  </button>
</div>
